"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreadProtocol = void 0;
// Thread protocol version
const version = "0.0.1";
// Thread protocol name
const name = "thread";
/**
 * ThreadProtocol describes the default Threads Protocol parameters
 */
exports.ThreadProtocol = {
    /**
     * Name is the protocol slug.
     */
    name,
    /**
     * Code is the protocol code.
     */
    code: 406,
    /**
     * Version is the current protocol version.
     */
    version,
    /**
     * Protocol is the threads protocol tag.
     */
    protocol: `/${name}/${version}`,
};
//# sourceMappingURL=thread.js.map